
<template>
  <!-- 注意事项页面 -->
  <div>
    <van-nav-bar
      class="backBox"
      title="注意事项"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content_box">
      <div class="tit">完成人脸收集</div>
      <div class="tit_small">为了您可以正常预约课程，请完成人脸收集</div>
      <div class="box">
        <van-image
          width="150"
          height="150"
          fit="cover"
          :src="require('../../assets/imgs/collection1@2x.png')"
        />
        <div class="img_tit">请将摄像头对准您的面部</div>
      </div>
      <div class="footer">
        <div class="tit_foot">
          <span class="tit_foot1">拍摄须知：</span>
          <span class="tit_foot2">请确保为您本人操作</span>
        </div>
        <div class="box_foot">
          <div class="img_foot">
            <!-- <img src="../../assets/imgs/collection2@2x.png" alt="" /> -->
            <van-image
              width="55"
              height="55"
              fit="cover"
              :src="require('../../assets/imgs/collection2@2x.png')"
            />
            <div class="text_foot">正对手机</div>
          </div>
          <div class="img_foot">
            <van-image
              width="55"
              height="55"
              fit="cover"
              :src="require('../../assets/imgs/collection3@2x.png')"
            />
            <div class="text_foot">光线充足</div>
          </div>
          <div class="img_foot">
            <van-image
              width="55"
              height="55"
              fit="cover"
              :src="require('../../assets/imgs/collection4@2x.png')"
            />
            <div class="text_foot">请勿偏移</div>
          </div>
        </div>
      </div>
      <div class="operationBtn">
        <van-button round block type="info" @click="startCollection"
          >开始采集</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {
    startCollection () {
      this.$router.replace('/catchFace')
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  padding: 1rem;
  .tit {
    font-size: 1.125rem;
    color: #333;
  }
  .tit_small {
    font-size: 0.875rem;
    color: #999;
    margin-top: 0.375rem;
  }
  .box {
    margin-top: 2.25rem;
    text-align: center;
    .img_tit {
      font-size: 0.75rem;
      color: #999;
      margin-top: 1.125rem;
    }
  }
  .footer {
    margin-top: 3.1875rem;
    .tit_foot1 {
      font-size: 1.125rem;
      color: #333;
    }
    .tit_foot2 {
      font-size: 0.875rem;
      color: #999;
    }
    .box_foot{
      margin-top: 1.0625rem;
      display: flex;
      justify-content: space-between;
      .text_foot{
        font-size: 14px;
        color: #666;
        margin-top: .5625rem;
      }
    }
  }
  .operationBtn{
    margin: 2.25rem 0 0 0;
  }
}
</style>
